import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function CreditsExhaustedDialog({ open, onClose, message }) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Credits exhausted</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          {message ||
            'Your organization has no remaining credits for this action. Contact support@workflow86.com to upgrade or add credits.'}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Dismiss</Button>
        <Button
          variant="contained"
          onClick={() => {
            onClose();
            navigate('/organization');
          }}
        >
          View billing
        </Button>
      </DialogActions>
    </Dialog>
  );
}
